import { render } from "./AddLokasi.vue?vue&type=template&id=41b96aed"
import script from "./AddLokasi.vue?vue&type=script&lang=js"
export * from "./AddLokasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__